<template>
  <v-card>
    <template>
      <v-card-title class="i-dialog-header-div">
        <span class="g-heading-m g-bold">{{ title }}</span>
      </v-card-title>

      <v-card-text class="py-4 text-center">
        <p>{{ text }}</p>

        <div class="mt-4 mb-2">
          <p class="mb-2 g-bold text-left">Publish Date (Optional)</p>
          <v-menu
            offset-y
            min-width="auto"
            transition="scale-transition"
            v-model="publishDateMenu"
            :close-on-content-click="false"
            :nudge-right="15"
            :nudge-top="30"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                append-icon="mdi-calendar"
                background-color="#0000000f"
                dense
                hide-details
                clearable
                label="Publish Date"
                outlined
                readonly
                v-on="on"
                v-model="formattedPublishDate"
              ></v-text-field>
            </template>
            <v-date-picker
              :min="currentDate"
              v-model="publishDate"
              @change="publishDateMenu = false"
            ></v-date-picker>
          </v-menu>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="justify-center">
        <v-btn rounded text class="i-btn-text-black" @click="handleClose"
          >Cancel</v-btn
        >
        <v-btn rounded class="i-btn-block-secondary" @click="handleConfirm">{{
          $filters.sentenceCase(actionText)
        }}</v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
import { minAllowedPromotionStartDate } from '@/modules/dataMaintenance/helper/PromotionPublishSchedule'

export default {
  data: () => ({
    publishDate: null,
    publishDateMenu: false
  }),

  props: {
    actionText: {
      default: 'Confirm',
      type: String
    },

    submitting: {
      default: false,
      type: Boolean
    },

    text: {
      required: true,
      type: String
    },

    title: {
      default: 'Confirmation',
      type: String
    },
    tenantCountryRegion: String
  },

  computed: {
    currentDate() {
      return minAllowedPromotionStartDate(this.tenantCountryRegion)
    },

    formattedPublishDate: {
      // getter
      get: function () {
        return this.$options.filters.formatDatePicker(this.publishDate)
      },
      // setter (we only need that since we introduced the "clearable" option on the text field
      set: function (newValue) {
        this.publishDate = newValue
      }
    }
  },

  methods: {
    handleClose() {
      this.$emit('cancel')
    },

    handleConfirm() {
      this.$emit('confirm', this.publishDate)
    }
  }
}
</script>
